// Defaults that work without a .env, pointing at the local demo backend.
const env = process.env;

export const defaults = {
    baseUrl: env.VUE_APP_XEENIA_BASE_URL || 'http://localhost:8000',
    token: env.VUE_APP_XEENIA_TOKEN || 'tok_xeenia_local',
    secret: env.VUE_APP_XEENIA_SECRET || 'sek_xeenia_local',
    patientId: env.VUE_APP_XEENIA_PATIENT_ID || 'XMED-DEMO-PATIENT-1',
};

export const BACKEND_DOWN_HINT = 'A backend nem válaszol a(z) {base} címen. '
    + 'Indítsd el a repó gyökeréből: "make dev" (API + worker + felületek), '
    + 'vagy csak az API-t: "cd apps/api && php artisan serve".';
